import { render, staticRenderFns } from "./auto-text-dialog.vue?vue&type=template&id=09c18504&scoped=true&"
import script from "./auto-text-dialog.vue?vue&type=script&lang=ts&"
export * from "./auto-text-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./auto-text-dialog.vue?vue&type=style&index=0&id=09c18504&prod&lang=scss&scoped=true&"
import style1 from "./auto-text-dialog.vue?vue&type=style&index=1&id=09c18504&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c18504",
  null
  
)

export default component.exports